<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M7.44998 6.55002C7.69849 6.79854 7.69849 7.20146 7.44998 7.44998L1.08634 13.8136C0.837825 14.0621 0.434902 14.0621 0.186387 13.8136C-0.062129 13.5651 -0.062129 13.1622 0.186387 12.9137L6.10005 7L0.186387 1.08634C-0.0621284 0.837825 -0.0621284 0.434902 0.186387 0.186387C0.434903 -0.0621289 0.837826 -0.0621289 1.08634 0.186387L7.44998 6.55002Z"
                :fill="color" />
        </svg>

    </div>
</template>

<script>
export default {
    name: 'IconSvgChevronRight',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>